import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";

import styles from "../LandingPage.module.scss";

const FeatureCard = ({ icon, titulo, texto }) => (
    <div className={styles.cardItem}>
        <div className={styles.cardInfo}>
            <div className={styles.cardIcon}>
                <LazyLoadImage alt="Foto" effect="opacity" src={icon} className="lazy-image" />
            </div>
            <div className={styles.cardTitle}>{titulo}</div>
            <div className={styles.cardText}>{texto}</div>
        </div>
    </div>
);

export default FeatureCard;
